import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import React from 'react';
import { Shimmer } from '../../../../ui';
import { Tile } from '../../../../ui/new-components/Tile';
import { useUserStore } from '../../../auth/user/domain/stores/useUserStore';
import { Section } from '../../../content-sections/ui/components/Section';
import { StyledFlexShortcutItem } from '../../../home/ui/shortcuts/StyledFlexShortcutGrid';
import { StyledShortcutDiv } from '../../../home/ui/shortcuts/StyledShortcut';
import { useAccountShortcuts } from './hooks/useAccountShortcuts';

export const AccountShortcutsSection = observer(() => {
	const { shortcuts } = useAccountShortcuts();
	const { isLoading } = useUserStore();

	if (isLoading) {
		return (
			<StyledSection>
				<StyledShortcutsContentWrap>
					<Shimmer aria-label="shimmer" style={{ flexGrow: 1 }}>
						<StyledShortcutDiv />
					</Shimmer>
				</StyledShortcutsContentWrap>
			</StyledSection>
		);
	}
	return (
		<StyledSection>
			<StyledShortcutsContentWrap role="list">
				{shortcuts.map((shortcut) => (
					<StyledFlexShortcutItem
						key={shortcut.title}
						number={shortcuts.length}
						role="listitem"
					>
						<Tile {...shortcut} />
					</StyledFlexShortcutItem>
				))}
			</StyledShortcutsContentWrap>
		</StyledSection>
	);
});

export const StyledSection = styled(Section)`
	padding-top: 20px 0;
`;

export const StyledShortcutsContentWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 24px;

	> div {
		margin-left: 0;
		margin-top: 0;
		flex-grow: 1;
	}
`;
